"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrostwardAbilityHandler = exports.FrostwardActorAbilityFactory = exports.FrostwardAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Settings_1 = require("../../Settings");
class FrostwardAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Frostward;
        this.__typeName = "Frostward";
    }
}
exports.FrostwardAbilityArgs = FrostwardAbilityArgs;
let FrostwardActorAbilityFactory = class FrostwardActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Frostward", "AllAllies", 3);
    }
};
FrostwardActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Frostward")
], FrostwardActorAbilityFactory);
exports.FrostwardActorAbilityFactory = FrostwardActorAbilityFactory;
let FrostwardAbilityHandler = class FrostwardAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const level = container.getLevel(ability.invokerId);
        const focus = container.getAttributeScore(ability.invokerId, enums_1.AttributeType.Focus);
        const damageResistance = Settings_1.BASE_LEVEL_ADR * level + Math.round(focus * .1);
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.removeDebuffs({
                    sequence,
                    removerId: ability.invokerId,
                    targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                        .map(targetId => ({
                        targetId,
                        includeSupernatural: false,
                        onDebuffsRemoved: sequence => {
                            container.applyBuff({
                                sequence: sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "IceExplosion")),
                                creatorId: ability.invokerId,
                                targetId,
                                duration: Duration_1.Duration.Turns(3),
                                effect: new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AllDamageResistance, damageResistance)
                            });
                        }
                    }))
                });
            }
        });
    }
};
FrostwardAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Frostward)
], FrostwardAbilityHandler);
exports.FrostwardAbilityHandler = FrostwardAbilityHandler;
